module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "ql-project-search",
    attrs: {
      "md-row": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('md-menu', {
    ref: "searchResultBox",
    staticClass: "ql-project-search-box-wrapper",
    attrs: {
      "md-align-trigger": "",
      "md-manual-toggle": true
    }
  }, [_c('md-input-container', {
    staticClass: "ql-project-search-box-container"
  }, [_c('md-autocomplete', {
    ref: "searchTermField",
    staticClass: "searchBox",
    attrs: {
      "placeholder": "Search",
      "min-chars": 1,
      "fetch": _vm.search,
      "prepare-response-data": _vm.output,
      "print-attribute": "text"
    },
    on: {
      "focus": _vm.triggerSearch,
      "selected": _vm.selectSearchResult
    },
    model: {
      value: (_vm.term),
      callback: function($$v) {
        _vm.term = $$v
      },
      expression: "term"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ql-project-search-type-box"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchType),
      expression: "searchType"
    }],
    staticClass: "btn-search-type",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selectSearchType($event.target.value)
      }]
    }
  }, _vm._l((_vm.searchTypes), function(type) {
    return _c('option', {
      key: type,
      staticClass: "md-list-item md-menu-item md-option",
      domProps: {
        "value": type
      }
    }, [_vm._v(_vm._s(type))])
  }), 0)]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-dense ql-project-search-box-button",
    on: {
      "click": _vm.triggerSearchBoxResult
    }
  }, [_c('md-icon', [_vm._v("search")])], 1)], 1), _vm._v(" "), (_vm.searchType !== 'script') ? _c('md-menu-content', {
    style: (_vm.searchResultListStyle())
  }, [_vm._l((_vm.searchResult), function(item, index) {
    return [(item.type === 'cue') ? _c('md-menu-item', {
      key: index,
      on: {
        "selected": function($event) {
          return _vm.selectSearchResult(item)
        }
      }
    }, [_c('div', {
      staticClass: "ql-search-result-item-cue"
    }, [_c('span', {
      staticClass: "first-line"
    }, [_vm._v(_vm._s(item.label) + " "), _c('strong', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('span', {
      staticClass: "second-line"
    }, [_vm._v(_vm._s(item.subline))])]), _vm._v("\n                             \n                            "), _c('span', [_vm._v("pg " + _vm._s(_vm.project.pdfPageNumbers && _vm.project.pdfPageNumbers[item.page - 1] &&
      _vm.project.pdfPageNumbers[item.page - 1].name && _vm.project.pdfPageNumbers[item.page - 1].name))])]) : _c('md-menu-item', {
      key: index,
      on: {
        "selected": function($event) {
          return _vm.selectSearchResult(item)
        }
      }
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(item.title))])]), _vm._v("\n                             \n                            "), _c('span', [_vm._v("pg " + _vm._s(_vm.project.pdfPageNumbers && _vm.project.pdfPageNumbers[item.page - 1] &&
      _vm.project.pdfPageNumbers[item.page - 1].name && _vm.project.pdfPageNumbers[item.page - 1].name))])])]
  }), _vm._v(" "), _c('md-menu-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.searchResult.length),
      expression: "!searchResult.length"
    }],
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("\n                        No " + _vm._s(_vm.searchType) + " found...\n                    ")])], 2) : _c('md-menu-content', {
    staticClass: "script-result-items-list",
    style: (_vm.searchResultListStyle())
  }, [_vm._l((_vm.searchResult), function(item, index) {
    return [(item.type === 'page') ? _c('md-menu-item', {
      key: index,
      staticClass: "script-result-item-page",
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("\n                            Page " + _vm._s(_vm.project.pdfPageNumbers && _vm.project.pdfPageNumbers[item.page - 1] &&
      _vm.project.pdfPageNumbers[item.page - 1].name && _vm.project.pdfPageNumbers[item.page - 1].name) + "\n                        ")]) : _c('md-menu-item', {
      key: index,
      staticClass: "script-result-item-line",
      on: {
        "selected": function($event) {
          return _vm.selectSearchResult(item)
        }
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })])]
  }), _vm._v(" "), _c('md-menu-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.searchResult.length),
      expression: "!searchResult.length"
    }],
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("\n                        Nothing found...\n                    ")])], 2)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-268c12fb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/search.vue
// module id = 1215
// module chunks = 21